import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from '../services/error.service';
import { environment } from '../environments/environment';
import { ApiResponse } from '../interfaces/api-response.interface';
import { WmPoolErrorResponse } from '../interfaces/api-response.interface';
import { WmMmsErrorResponse } from '../interfaces/api-response.interface';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.indexOf(environment.poolApi) !== -1 || req.url.indexOf(environment.mmsApi) !== -1) {
      return next.handle(req).pipe(
        map((event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
            const body = event.body as ApiResponse | WmPoolErrorResponse | WmMmsErrorResponse;

            if (body && body.status === false) {
              throw this.errorService.handle(body);
            } else {
              event = event.clone({ body: body.result });
            }
          }

          return event;
        }),
        catchError((error: unknown) => {
          if (error instanceof HttpErrorResponse) {
            return throwError(() =>
              this.errorService.handle({
                message: 'Network Error',
                status: false,
                data: undefined,
                errorCode: '',
                result: undefined,
              })
            );
          } else {
            return throwError(() => error);
          }
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
